import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './info-icon-caption.styl'

export default class InfoIconCaption extends Component {
  static propTypes = {
    caption: PropTypes.any,
    marginRight: PropTypes.string,
    colorClass: PropTypes.string,
    ico: PropTypes.string,
  }

  static defaultProps = {
    marginRight: '15px'
  }

  render() {
    const { ico, caption, colorClass, marginRight } = this.props

    const classNames = [
      styles.wrap,
      styles[colorClass]
    ]

    return (
      <span className={classNames.join(' ')} style={{ marginRight }}>
        <i className={`ico ico--${ico} ${styles.icon}`} />
        <span className={styles.caption}>
          {caption}
        </span>
      </span>
    )
  }
}
